
































helpers = require('../../helpers.coffee')

view_model =
  components:
    filters: require('./filters.vue')
    listItem: require('./list_item.vue')
    showModal: require('./show_modal.vue')

  props: ['options', 'list_item_options', 'filter_options']

  data: ->
    templates: []
    modal_template: null
    selected_template_to_destroy: {}
    filters: {}
    loading: false
    next_page: 1

    default_options:
      only_current_user_templates: true

  methods:
    loadTemplates: ->
      return if @loading || !@next_page
      @loading = true
      @templates_resource.index(@loadTemplatesSuccess, Loader.off, params: {q: @buildFilters(), page: @next_page})

    loadTemplatesSuccess: (resources) ->
      @next_page = resources.meta.next_page
      @loading = false
      @templates = @templates.concat(resources.templates)

    showTemplate: (template) ->
      @modal_template = template
      jQuery('#template-show').modal('show')

    showDestroyConfirmationModal: (template) ->
      @selected_template_to_destroy = template
      EventsBus.$emit('confirm-modal-show', id: 'destroy-template-confirmation-modal')

    destroy: ->
      Loader.on()
      id = @selected_template_to_destroy.id
      new TemplatesResource().destroy(@destroySuccess(id), @destroyFailure, {id})

    destroySuccess: (id) ->
      () =>
        Loader.off()
        @templates.remove(id)
        alertify.success this.$t('template.feedback.removeSuccess')

    destroyFailure: ->
      Loader.off()
      alertify.error this.$t('template.feedback.removeFail')

    filter: (filters) ->
      @filters = filters
      @templates = []
      @next_page = 1
      @loadTemplates()

    buildFilters: ->
      if @default_options.only_current_user_templates
        @mergeCurrentUserFilterIfSeller(@filters)
      else
        @filters

  computed:
    destroy_confirm_modal_message: ->
      this.$t('template.label.removeTemplateByNameConfirm', { name: @selected_template_to_destroy.name })

  created: ->
    @setFiltersFromQueryParams()
    @templates_resource = new TemplatesResource Session.current_company.id
    @default_options = Object.assign(@default_options, @options)
    @loadTemplates()

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/list.vue